module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui message"
  }, [_c('i', {
    staticClass: "close icon",
    on: {
      "click": _vm.del
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v("\n    " + _vm._s(_vm.task.title) + "\n  ")]), _vm._v(" "), _c('i', {
    staticClass: "wait icon"
  }), _vm._v("\n    " + _vm._s(_vm.taskDate) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9df41ace","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/todo/Item.vue
// module id = 27
// module chunks = 0